var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlorinSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 56C384 69.25 373.25 80 360 80H308.984C292.172 80 277.047 90.625 271.344 106.438L226.143 232H328C341.25 232 352 242.75 352 256S341.25 280 328 280H208.863L157.812 421.812C145.281 456.625 112 480 75.016 480H24C10.75 480 0 469.25 0 456S10.75 432 24 432H75.016C91.828 432 106.953 421.375 112.656 405.562L157.857 280H56C42.75 280 32 269.25 32 256S42.75 232 56 232H175.137L226.188 90.188C238.719 55.375 272 32 308.984 32H360C373.25 32 384 42.75 384 56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlorinSign);
export default __webpack_public_path__ + "static/media/florin-sign.3f30a88ee55e8b03af851af1581dc6ed.svg";
export { ForwardRef as ReactComponent };